import type { LucideIcon } from 'lucide-react';

export function MetricCard({
  label,
  value,
  sub,
  icon: Icon,
  trend,
}: {
  label: string;
  value: string | number;
  sub?: string;
  icon?: LucideIcon;
  trend?: 'up' | 'down' | 'flat';
}): JSX.Element {
  const trendColor =
    trend === 'up' ? 'var(--success)' : trend === 'down' ? 'var(--danger)' : 'var(--text-muted)';
  return (
    <div
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '16px 18px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span
          style={{
            fontSize: 10,
            color: 'var(--text-muted)',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            fontWeight: 500,
          }}
        >
          {label}
        </span>
        {Icon && (
          <span
            style={{
              display: 'inline-flex',
              fontSize: 10,
              color: 'var(--text-muted)',
              background: 'var(--bg-card-hi)',
              padding: '2px 6px',
              borderRadius: 4,
              fontFamily: 'var(--font-mono)',
              alignItems: 'center',
              gap: 3,
            }}
          >
            <Icon size={11} strokeWidth={2} />
          </span>
        )}
      </div>
      <div
        style={{
          fontFamily: 'var(--font-mono)',
          fontSize: 30,
          fontWeight: 500,
          letterSpacing: '-0.03em',
          color: 'var(--text)',
          lineHeight: 1,
        }}
      >
        {value}
      </div>
      {sub && (
        <div style={{ fontSize: 11, fontFamily: 'var(--font-mono)', color: trendColor }}>
          {sub}
        </div>
      )}
    </div>
  );
}
